/* eslint-disable no-underscore-dangle */
import { AxiosInstance } from 'axios';

export class Container {
  private static _phishedClient: AxiosInstance;

  private static _zimClient: AxiosInstance;

  private static _zimHealthClient: AxiosInstance;

  private static _graphClient: AxiosInstance;

  private static _accessTokenValidatorClient: AxiosInstance;

  public static registerPhishedClient(instance: AxiosInstance) {
    this._phishedClient = instance;
  }

  public static registerZimClient(instance: AxiosInstance) {
    this._zimClient = instance;
  }

  public static registerZimHealthClient(instance: AxiosInstance) {
    this._zimHealthClient = instance;
  }

  public static registerGraphClient(instance: AxiosInstance) {
    this._graphClient = instance;
  }

  public static registerAccessTokenValidatorValidator(instance: AxiosInstance) {
    this._accessTokenValidatorClient = instance;
  }

  public static get phishedClient() {
    return this._phishedClient;
  }

  public static get zimClient() {
    return this._zimClient;
  }

  public static get zimHealthClient() {
    return this._zimHealthClient;
  }

  public static get graphClient() {
    return this._graphClient;
  }

  public static get accessTokenValidatorClient() {
    return this._accessTokenValidatorClient;
  }
}
